export default __webpack_public_path__ + "static/media/news78.8fab2e07.jpg";